"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@platform-export/success",
  ERROR: "@@platform-export/error",
  EXPORT_ALL_TENANT_USER_DETAILS: "@@platform-export/export-all-tenant-user-details",
  EXPORT_RESET: "@@platform-export/export-reset"
};
exports.actionTypes = actionTypes;